module.exports = __webpack_public_path__ + "img/45.ebf061af.svg";